import { UsageLevelTags } from "../../utils/commonInterfaces";
import { ArrowUpOutlined , MinusOutlined , ArrowDownOutlined } from "@ant-design/icons";

export const renderUsageLevelFlag = (UsageLevelTag: UsageLevelTags | null) => {
    let label = '';
    let background = '';
    let color = '';
    let IconComponent: React.ReactNode = <></>;



    if (UsageLevelTag === UsageLevelTags.High) {
        label = 'High';
        background = '#f6ffed';
        color = '#237804';
        IconComponent = <ArrowUpOutlined />;
    } else if (UsageLevelTag === UsageLevelTags.Medium) {
        label = 'Medium';
        background = '#fffbe6';
        color = '#ad6800';
        IconComponent = <MinusOutlined />;
    }
    else if (UsageLevelTag === UsageLevelTags.Low) {
        label = 'Low';
        background = '#ffccc7';
        color = '#a8071a';
        IconComponent = <ArrowDownOutlined />;
    }

    return (
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2px 10px',
                borderRadius: '999px',
                fontSize: '12px',
                fontWeight: 600,
                background,
                color,
                minWidth: '60px',
                textAlign: 'center',
                border: `1px solid ${color}`,
            }}
        >
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                {IconComponent}
                <span>{label}</span>
            </span>
        </span>
    );
}